import ProfileHeaderContent from './ProfileHeaderContent';

const PrimaryPhoneNumberComponent = ({
  t,
  phoneNumber,
}: {
  t: (key: string) => string;
  phoneNumber: string;
}) => {
  const handlePhoneNoChange = (phone: string) => {
    if (!phone || phone.length !== 10) {
      return phone; // Return as is if not a valid 10-digit phone number
    }
    const areaCode = phone.slice(0, 3);
    const centralOfficeCode = phone.slice(3, 6);
    const lineNumber = phone.slice(6);
    return `(${areaCode}) ${centralOfficeCode}-${lineNumber}`;
  };

  const processedPhoneNumber = handlePhoneNoChange(phoneNumber);

  return (
    <ProfileHeaderContent
      contentClassNameOne="mb-0"
      header={t('common.primaryPhoneNumber')}
      contentOne={processedPhoneNumber}
      dataTestIdOne="textNotificationsContent"
      disabledText={true}
    />
  );
};

export default PrimaryPhoneNumberComponent;
